import COLORS, { colorSteps, colorStepsReverse } from 'theme/colors';

export const pickTextColorBasedOnBgColor = (bgColor: string): string | undefined => {
  if (!bgColor) return undefined;
  const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
  const r = parseInt(color.substring(0, 2), 16); // hexToR
  const g = parseInt(color.substring(2, 4), 16); // hexToG
  const b = parseInt(color.substring(4, 6), 16); // hexToB
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? COLORS.black.base : COLORS.silver.lightest;
};

export const getColorStep = (color: string): string => {
  return color?.split('.')[1];
};

export const getBaseColor = (color: string): string => {
  return color?.split('.')[0];
};

export const getOneStepLighterColor = (color: string): string => {
  const colorStep = getColorStep(color);
  const indexOfColorStep = colorSteps.indexOf(colorStep);
  const isLightest = indexOfColorStep === 0;
  const nextIndex = isLightest ? indexOfColorStep + 1 : indexOfColorStep - 1;
  return `${getBaseColor(color)}.${colorSteps[nextIndex]}`;
};

export const getOneStepDarkerColor = (color: string): string => {
  const colorStep = getColorStep(color);
  const indexOfColorStep = colorStepsReverse.indexOf(colorStep);
  const isDarkest = indexOfColorStep === 0;
  const nextIndex = isDarkest ? indexOfColorStep + 1 : indexOfColorStep - 1;
  return `${getBaseColor(color)}.${colorStepsReverse[nextIndex]}`;
};
